import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { Field } from 'formik'
import { IconMenu2, IconInfoCircle, IconTrash } from '@tabler/icons-react'
import { isEmpty } from 'lodash'

import { Button } from '@/components/buttons/Button'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { Checkbox, TextField } from '@/components/forms/formik'

import './editSectionsForm.css'

export const EditSectionsRow = ({
  items,
  index,
  remove,
  shouldFocus,
  errors,
  removeObject,
  updateWeight,
  updateStatusInObject,
  updateNameInObject,
  disableDraggable = false,
}) => {
  const currentSection = items[index]

  return (
    <Draggable
      draggableId={currentSection.id.toString()}
      index={index}
      isDragDisabled={disableDraggable}
    >
      {(provided) => {
        return (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            className="edit-scorecard-form__row"
          >
            {!disableDraggable && (
              <div className="edit-scorecard-form__drag-handle">
                <IconMenu2 size={16} />
              </div>
            )}
            <div className="edit-scorecard-form__name">
              <Field
                name={`sections.${index}.name`}
                errorMessage={errors?.sections && errors.sections[index]?.name}
                data-testid={`sections.${index}.name`}
                disabled={!currentSection.active}
                component={TextField}
                type="text"
                max="100"
                placeholder="Section Name"
                autoFocus={shouldFocus}
                onChange={(event) => updateNameInObject(event, currentSection)}
              />
            </div>
            <InteractiveTooltip
              content={
                <div>
                  <strong className="mb">
                    {currentSection?.measures?.length > 0 ? 'Included Measures' : 'No Measures'}
                  </strong>
                  <div className="flex-column" style={{ gap: '4px' }}>
                    {!isEmpty(currentSection?.measures) &&
                      currentSection.measures.map((measure) => (
                        <div key={measure.id}>{measure.name}</div>
                      ))}
                  </div>
                </div>
              }
            >
              <IconInfoCircle className="icon-svg" />
            </InteractiveTooltip>
            <Field name={`sections.${index}.active`} label={null}>
              {(formikProps) => (
                <Checkbox
                  toggle
                  data-testid="section-active-toggle"
                  {...formikProps}
                  onClick={() => updateStatusInObject(currentSection)}
                />
              )}
            </Field>
            <div className="edit-scorecard-form__weight">
              <Field
                name={`sections.${index}.weight`}
                data-testid={`sections.${index}.weight`}
                disabled={!currentSection.active}
                component={TextField}
                type="number"
                label={null}
                max="100"
                placeholder="0"
                onChange={(event) => updateWeight(event, currentSection)}
              />
            </div>
            <Button
              critical
              square
              data-testid="basic-modal-delete-button"
              onClick={() => {
                remove(index)
                removeObject(currentSection)
              }}
            >
              <IconTrash />
            </Button>
          </div>
        )
      }}
    </Draggable>
  )
}
